(function () {
  function markScrolled() {
    document.body.classList.toggle('cv-scrolled', window.scrollY > 12);
  }

  function initRevealObserver() {
    var nodes = document.querySelectorAll('[data-cv-reveal]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.18 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initMobileMenuLabel() {
    document.querySelectorAll('.cv-mobile-nav').forEach(function (nav) {
      var summary = nav.querySelector('summary');
      if (!summary) return;
      var label = summary.querySelector('[data-cv-mobile-label]');

      function syncLabel() {
        if (label) {
          label.textContent = nav.open ? 'Fermer' : 'Menu';
        }
      }

      nav.addEventListener('toggle', syncLabel);
      syncLabel();
    });
  }

  function initStickyProductOffset() {
    var stickyBuy = document.querySelector('.cv-product-sticky-buy');
    if (!stickyBuy) return;

    document.documentElement.style.setProperty('--cv-mobile-buy-height', stickyBuy.offsetHeight + 'px');

    window.addEventListener(
      'resize',
      function () {
        document.documentElement.style.setProperty('--cv-mobile-buy-height', stickyBuy.offsetHeight + 'px');
      },
      { passive: true }
    );
  }

  function init() {
    markScrolled();
    initRevealObserver();
    initMobileMenuLabel();
    initStickyProductOffset();
  }

  window.addEventListener('scroll', markScrolled, { passive: true });
  window.addEventListener('resize', markScrolled, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
